"use client";

export default function DiabeticFootSurgeryFellowship() {
  return (
    <>
      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

.sldfsf-wrap{font-family:'Inter',Arial,sans-serif;color:#1c1c1c;line-height:1.65;margin:0 auto;padding:30px 60px;}
.sldfsf-wrap *{box-sizing:border-box;}

/* HERO */
.sldfsf-hero{display:table;width:100%;background:linear-gradient(145deg,#0F241C 0%,#173a2b 60%,#0F241C 100%);padding:64px 48px;border-radius:18px;margin-bottom:24px;box-shadow:0 12px 30px rgba(15,36,28,0.25);position:relative;}
.sldfsf-hero-inner{display:table-cell;vertical-align:middle;}
.sldfsf-hero-tag{display:inline-block;background:#08A854;color:#ffffff;font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:7px 16px;border-radius:20px;margin-bottom:20px;box-shadow:0 4px 12px rgba(8,168,84,0.35);}
.sldfsf-hero h1{color:#ffffff;font-size:36px;font-weight:800;margin:0 0 14px 0;line-height:1.28;letter-spacing:-0.3px;}
.sldfsf-hero h2{color:#8fd6b0;font-size:17px;font-weight:600;margin:0 0 18px 0;letter-spacing:.1px;}
.sldfsf-hero p{color:#c9d8d1;font-size:15.5px;margin:0 0 26px 0;max-width:780px;}
.sldfsf-hero-btns a{display:inline-block;padding:14px 28px;border-radius:9px;font-weight:700;font-size:14px;text-decoration:none;margin:0 10px 10px 0;transition:transform .15s ease;box-shadow:0 6px 16px rgba(8,168,84,0.3);}
.sldfsf-hero-primary{background:#08A854;color:#ffffff !important;}

/* DEADLINE STRIP */
.sldfsf-deadline{display:table;width:100%;background:#fdf6ea;border:1px solid #f0d9a6;border-left:4px solid #c98a1a;border-radius:10px;padding:18px 24px;margin-bottom:40px;box-shadow:0 2px 8px rgba(201,138,26,0.08);}
.sldfsf-deadline-text{display:table-cell;vertical-align:middle;font-size:14.5px;color:#5c4210;letter-spacing:.1px;}
.sldfsf-deadline-text b{color:#0F241C;font-weight:800;}

/* SECTION TITLES */
.sldfsf-section{padding:26px 0 10px 0;}
.sldfsf-eyebrow{color:#08A854;font-weight:700;font-size:12.5px;text-transform:uppercase;letter-spacing:1.2px;margin-bottom:10px;}
.sldfsf-h2{font-size:27px;font-weight:800;color:#0F241C;margin:0 0 20px 0;letter-spacing:-0.2px;position:relative;padding-bottom:14px;}
.sldfsf-h2::after{content:"";display:block;width:52px;height:4px;background:#08A854;border-radius:4px;position:absolute;bottom:0;left:0;}
.sldfsf-intro p{font-size:15.5px;color:#3d4a44;margin:0 0 40px 0;}

/* STATS BAR */
.sldfsf-statsbar{display:table;width:100%;table-layout:fixed;background:#0F241C;border-radius:16px;margin-bottom:40px;overflow:hidden;box-shadow:0 10px 24px rgba(15,36,28,0.18);}
.sldfsf-stat{display:table-cell;padding:30px 18px;text-align:center;border-right:1px solid rgba(255,255,255,.1);vertical-align:middle;}
.sldfsf-stat:last-child{border-right:none;}
.sldfsf-stat-num{font-size:28px;font-weight:800;color:#ffffff;letter-spacing:-0.3px;}
.sldfsf-stat-label{font-size:11.5px;color:#8fd6b0;margin-top:8px;text-transform:uppercase;letter-spacing:.5px;line-height:1.5;}

/* MENTOR CARD */
.sldfsf-mentor{display:table;width:100%;background:#ffffff;border:1px solid #e3ede8;border-radius:16px;padding:34px;margin-bottom:40px;box-shadow:0 8px 24px rgba(15,36,28,0.06);position:relative;overflow:hidden;}
.sldfsf-mentor::before{content:"";position:absolute;top:0;left:0;width:6px;height:100%;background:#08A854;}
.sldfsf-mentor-avatar{display:table-cell;width:114px;vertical-align:top;}
.sldfsf-mentor-avatar-circle{width:92px;height:92px;border-radius:50%;background:linear-gradient(145deg,#0F241C,#1e4230);color:#ffffff;font-size:26px;font-weight:800;letter-spacing:1px;text-align:center;line-height:92px;box-shadow:0 8px 18px rgba(15,36,28,0.25);overflow:hidden;}
.sldfsf-mentor-avatar-circle img{width:100%;height:100%;object-fit:cover;display:block;}
.sldfsf-mentor-body{display:table-cell;vertical-align:top;padding-left:26px;}
.sldfsf-mentor-body h3{margin:0 0 5px 0;font-size:21px;color:#0F241C;font-weight:800;}
.sldfsf-mentor-body .sldfsf-mentor-role{color:#08A854;font-weight:700;font-size:12.5px;text-transform:uppercase;letter-spacing:.6px;margin-bottom:12px;}
.sldfsf-mentor-body p{margin:0;font-size:14.5px;color:#4a5750;}

/* GRID CARDS (generic 3-col) */
.sldfsf-grid3{display:table;width:100%;table-layout:fixed;margin-bottom:40px;border-spacing:18px 0;}
.sldfsf-grid3-cell{display:table-cell;width:33.33%;vertical-align:top;}
.sldfsf-card{background:#ffffff;border:1px solid #e3ede8;border-top:3px solid #08A854;border-radius:12px;padding:24px 22px;height:100%;box-shadow:0 4px 14px rgba(15,36,28,0.05);}
.sldfsf-card h4{margin:0 0 9px 0;font-size:16px;color:#0F241C;font-weight:800;letter-spacing:-0.1px;}
.sldfsf-card p{margin:0;font-size:13.5px;color:#5b6862;}

/* SERVICES LIST (checklist) */
.sldfsf-checklist{list-style:none;margin:0 0 40px 0;padding:0;display:table;width:100%;table-layout:fixed;border-spacing:0 12px;}
.sldfsf-checklist li{display:table-row;}
.sldfsf-check-text{display:table-cell;font-size:14.5px;font-weight:500;color:#243330;vertical-align:middle;background:#f4faf6;border-left:4px solid #08A854;border-radius:0 8px 8px 0;padding:15px 18px;box-shadow:0 2px 8px rgba(15,36,28,0.04);}

/* TEAM PILLS */
.sldfsf-pills{margin-bottom:40px;}
.sldfsf-pill{display:inline-block;background:#0F241C;color:#ffffff;font-size:13px;font-weight:600;padding:10px 18px;border-radius:22px;margin:0 10px 10px 0;box-shadow:0 3px 10px rgba(15,36,28,0.15);}

/* ELIGIBILITY BOX */
.sldfsf-eligibility{display:table;width:100%;background:linear-gradient(145deg,#0F241C,#173a2b);border-radius:16px;padding:34px 36px;margin-bottom:40px;box-shadow:0 10px 24px rgba(15,36,28,0.18);}
.sldfsf-elig-col{display:table-cell;width:50%;vertical-align:top;padding-right:20px;}
.sldfsf-elig-col h4{color:#8fd6b0;font-size:12.5px;text-transform:uppercase;letter-spacing:.6px;margin:0 0 10px 0;font-weight:700;}
.sldfsf-elig-col p{color:#ffffff;font-size:16px;font-weight:600;margin:0;}

/* CTA FOOTER */
.sldfsf-cta{display:table;width:100%;background:linear-gradient(145deg,#0F241C 0%,#1c4a35 100%);border-radius:18px 18px 0 0;padding:46px 36px;text-align:center;}
.sldfsf-cta h3{color:#ffffff;font-size:24px;font-weight:800;margin:0 0 12px 0;letter-spacing:-0.2px;}
.sldfsf-cta p{color:#c9d8d1;font-size:14.5px;margin:0 0 26px 0;}
.sldfsf-cta-btns{display:table;margin:0 auto 22px auto;}
.sldfsf-cta-btns a{display:inline-block;padding:14px 28px;border-radius:9px;font-weight:700;font-size:14px;text-decoration:none;margin:0 8px 10px 8px;box-shadow:0 6px 16px rgba(8,168,84,0.3);}
.sldfsf-cta-primary{background:#08A854;color:#ffffff !important;}

/* CONTACT STRIP (business-card style footer bar) */
.sldfsf-contactstrip{display:table;width:100%;table-layout:fixed;background:#08A854;border-radius:0 0 18px 18px;padding:26px 34px;box-shadow:0 10px 24px rgba(8,168,84,0.2);}
.sldfsf-contact-cell{display:table-cell;vertical-align:top;padding:0 18px;border-right:1px solid rgba(255,255,255,.28);}
.sldfsf-contact-cell:last-child{border-right:none;}
.sldfsf-contact-cell p{margin:0;color:#ffffff;font-size:13px;line-height:1.6;}
.sldfsf-contact-cell p b{display:block;font-size:12.5px;margin-bottom:4px;font-weight:700;letter-spacing:.2px;}
.sldfsf-contact-cell a{color:#ffffff;text-decoration:none;border-bottom:1px solid rgba(255,255,255,.4);}

/* RESPONSIVE */
@media (max-width:900px){
  .sldfsf-wrap{padding:24px 32px;}
  .sldfsf-statsbar{display:block;}
  .sldfsf-stat{display:block;border-right:none;border-bottom:1px solid rgba(255,255,255,.1);}
  .sldfsf-grid3{display:block;border-spacing:0;}
  .sldfsf-grid3-cell{display:block;width:100%;margin-bottom:16px;}
  .sldfsf-mentor{display:block;}
  .sldfsf-mentor-avatar{display:block;margin-bottom:16px;}
  .sldfsf-mentor-body{display:block;padding-left:0;}
  .sldfsf-eligibility{display:block;}
  .sldfsf-elig-col{display:block;width:100%;padding-right:0;margin-bottom:18px;}
  .sldfsf-contactstrip{display:block;}
  .sldfsf-contact-cell{display:block;border-right:none;border-bottom:1px solid rgba(255,255,255,.28);padding:16px 0;}
  .sldfsf-contact-cell:last-child{border-bottom:none;}
}
@media (max-width:600px){
  .sldfsf-wrap{padding:18px 16px;}
  .sldfsf-hero{padding:36px 24px;}
  .sldfsf-hero h1{font-size:24px;}
  .sldfsf-hero-btns a,.sldfsf-cta-btns a{display:block;margin:8px auto;max-width:280px;text-align:center;}
  .sldfsf-card,.sldfsf-mentor,.sldfsf-eligibility{padding:22px;}
}
      `}</style>

      <div
        dangerouslySetInnerHTML={{
          __html: `
<div class="sldfsf-wrap">

  <!-- HERO -->
  <div class="sldfsf-hero">
    <div class="sldfsf-hero-inner">
      <span class="sldfsf-hero-tag">Exclusive MUHS Fellowship Opportunity</span>
      <h1>MUHS Fellowship in Diabetic Foot Surgery</h1>
      <h2>Under the Mentorship of Dr. Arun Bal, MS PhD — Director, Diabetic Foot Surgery</h2>
      <p>Build a rewarding career at S.L. Raheja Hospital – A Fortis Associate (MUHS Recognized). Join India's premier fellowship program and acquire specialized surgical expertise in limb salvage from the pioneers of Diabetic Foot Surgery in India.</p>
      <div class="sldfsf-hero-btns">
        <a href="tel:9969453708" class="sldfsf-hero-primary">Call 9969453708</a>
        <a href="tel:9004479506" class="sldfsf-hero-primary">Call 9004479506</a>
      </div>
    </div>
  </div>

  <!-- DEADLINE STRIP -->
  <div class="sldfsf-deadline">
    <div class="sldfsf-deadline-text"><b>Last Date of Admission: August 31, 2026.</b> Eligibility: MS / DNB in General Surgery or Orthopedics, preferably with MMC Registration.</div>
  </div>

  <!-- INTRO -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Why This Fellowship Matters</div>
    <h2 class="sldfsf-h2">A Critical Healthcare Need. A Career-Defining Opportunity.</h2>
  </div>
  <div class="sldfsf-intro">
    <p>India faces a critical healthcare crisis with 131 million diabetes patients, 10–15% of whom suffer from foot ulcers, leading to over 250,000 annual leg amputations that mostly affect young adults aged 35–50. This is your opportunity to acquire specialized surgical expertise by joining India's premier fellowship program at S. L. Raheja Hospital (A Fortis Associate).</p>
  </div>

  <!-- STATS BAR -->
  <div class="sldfsf-statsbar">
    <div class="sldfsf-stat">
      <div class="sldfsf-stat-num">41 Yrs</div>
      <div class="sldfsf-stat-label">India's First Comprehensive Diabetes Care Center</div>
    </div>
    <div class="sldfsf-stat">
      <div class="sldfsf-stat-num">Est. 1987</div>
      <div class="sldfsf-stat-label">First Diabetic Foot Surgery Dept. in India &amp; SE Asia</div>
    </div>
    <div class="sldfsf-stat">
      <div class="sldfsf-stat-num">80–85%</div>
      <div class="sldfsf-stat-label">Foot Salvage Rate</div>
    </div>
    <div class="sldfsf-stat">
      <div class="sldfsf-stat-num">24 Surgeons</div>
      <div class="sldfsf-stat-label">Trained Since 2013, Now Practicing Across Maharashtra</div>
    </div>
  </div>

  <!-- MENTOR CARD -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Your Mentor</div>
    <h2 class="sldfsf-h2">Learn Directly Under a Pioneer</h2>
  </div>
  <div class="sldfsf-mentor">
    <div class="sldfsf-mentor-avatar">
      <div class="sldfsf-mentor-avatar-circle"><img src="https://cdn.docfyn.com/com.harbor/documents/2026/09/03/b34986912fb22089087942c6a64d9c4b15cf0b8d/whatsapp-image-2026-09-03-at-14.webp" alt="Dr. Arun Bal" /></div>
    </div>
    <div class="sldfsf-mentor-body">
      <h3>Dr. Arun Bal, MS PhD</h3>
      <div class="sldfsf-mentor-role">Director — Diabetic Foot Surgery</div>
      <p>Dr. Arun Bal started the Diabetic Foot Surgery Department at S.L. Raheja Hospital in 1987 — the first of its kind in India and Southeast Asia, and now the largest such setup in the country. Since 2013, 24 young surgeons mentored by Dr. Bal have graduated from this 1-year MUHS Fellowship and are currently leading successful practices across Maharashtra.</p>
    </div>
  </div>

  <!-- CLINICAL VOLUME -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Key Highlights</div>
    <h2 class="sldfsf-h2">Annual Clinical Volume</h2>
  </div>
  <div class="sldfsf-grid3">
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>9,500+ Outpatients</h4>
        <p>High-volume OPD exposure across the diabetic foot spectrum every year.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>1,400+ Surgeries</h4>
        <p>Hands-on surgical training in limb salvage and reconstructive procedures.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>1,600+ Angioplasties</h4>
        <p>Extensive peripheral angioplasty exposure alongside surgical training.</p>
      </div>
    </div>
  </div>

  <!-- SPECIALIZED SERVICES -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Clinical Exposure</div>
    <h2 class="sldfsf-h2">Advanced Diabetic Foot &amp; Salvage Specialized Services</h2>
  </div>
  <ul class="sldfsf-checklist">
    <li><div class="sldfsf-check-text">Charcot Foot Clinic</div></li>
    <li><div class="sldfsf-check-text">WOM / tcPO2 &amp; VAC / NPWT Therapy</div></li>
    <li><div class="sldfsf-check-text">RECOSMA YAG Laser</div></li>
    <li><div class="sldfsf-check-text">Stem Cell Therapy</div></li>
    <li><div class="sldfsf-check-text">Foot Assessment &amp; Ulcer Preventive Clinics</div></li>
    <li><div class="sldfsf-check-text">Home Wound Care Services</div></li>
  </ul>

  <!-- INFRASTRUCTURE -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Infrastructure</div>
    <h2 class="sldfsf-h2">Train With World-Class Facilities</h2>
  </div>
  <div class="sldfsf-grid3">
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>8 Modular OTs</h4>
        <p>State-of-the-art operating theatres for surgical training.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>3 Ultra-Modern ICUs</h4>
        <p>Comprehensive critical care support across specialties.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>Dedicated Cath Lab</h4>
        <p>Supports peripheral angioplasty and vascular interventions.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>BMT Unit</h4>
        <p>Bone marrow transplant unit within the same hospital campus.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>3T MRI &amp; PET Scan</h4>
        <p>Advanced imaging for precise diagnosis and treatment planning.</p>
      </div>
    </div>
    <div class="sldfsf-grid3-cell">
      <div class="sldfsf-card">
        <h4>NABL-Accredited Labs</h4>
        <p>Reliable, accredited diagnostics supporting every case.</p>
      </div>
    </div>
  </div>

  <!-- MULTIDISCIPLINARY TEAM -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Academic Environment</div>
    <h2 class="sldfsf-h2">Learn Alongside a Multidisciplinary Team</h2>
  </div>
  <div class="sldfsf-pills">
    <span class="sldfsf-pill">Senior Diabetologists</span>
    <span class="sldfsf-pill">Endocrinologists</span>
    <span class="sldfsf-pill">Vascular &amp; Endovascular Surgeons</span>
    <span class="sldfsf-pill">Infectious Disease Specialists</span>
    <span class="sldfsf-pill">Rheumatologists</span>
    <span class="sldfsf-pill">Ophthalmologists</span>
    <span class="sldfsf-pill">Haematologists</span>
  </div>

  <!-- ELIGIBILITY -->
  <div class="sldfsf-section">
    <div class="sldfsf-eyebrow">Admission Details</div>
    <h2 class="sldfsf-h2">Eligibility &amp; Deadline</h2>
  </div>
  <div class="sldfsf-eligibility">
    <div class="sldfsf-elig-col">
      <h4>Eligibility</h4>
      <p>MS / DNB in General Surgery or Orthopedics, preferably with MMC Registration.</p>
    </div>
    <div class="sldfsf-elig-col">
      <h4>Last Date of Admission</h4>
      <p>August 31, 2026</p>
    </div>
  </div>

  <!-- CTA -->
  <div class="sldfsf-cta">
    <h3>Transform Your Surgical Career. Become a Leader in Limb Salvage.</h3>
    <p>Apply now for the MUHS Fellowship in Diabetic Foot Surgery at S.L. Raheja Hospital (A Fortis Associate), Mahim, Mumbai, Maharashtra.</p>
    <div class="sldfsf-cta-btns">
      <a href="tel:9969453708" class="sldfsf-cta-primary">Call 9969453708</a>
      <a href="tel:9004479506" class="sldfsf-cta-primary">Call 9004479506</a>
    </div>
  </div>

  <!-- CONTACT STRIP -->
  <div class="sldfsf-contactstrip">
    <div class="sldfsf-contact-cell">
      <p><b>S.L. Raheja Hospital – A Fortis Associate</b>Raheja Rugnalaya Marg, Mahim West, Mumbai – 16</p>
    </div>
    <div class="sldfsf-contact-cell">
      <p><b>Call:</b><a href="tel:9969453708">9969453708</a> / <a href="tel:9004479506">9004479506</a></p>
    </div>
    <div class="sldfsf-contact-cell">
      <p><b>Reach out to us:</b>
        <a href="mailto:neha.tare@rahejahospital.com">neha.tare@rahejahospital.com</a><br>
        <a href="mailto:apoorva.prabhu@rahejahospital.com">apoorva.prabhu@rahejahospital.com</a><br>
        <a href="mailto:SLRH.Academics@rahejahospital.com">SLRH.Academics@rahejahospital.com</a>
      </p>
    </div>
    <div class="sldfsf-contact-cell">
      <p><b>Website:</b><a href="https://www.rahejahospital.com">www.rahejahospital.com</a></p>
    </div>
  </div>

</div>
          `,
        }}
      />
    </>
  );
}
